import { useCallback, useEffect } from 'react';

import { useModal } from './useModal';

export const useModalListeners = () => {
  const { hideModal } = useModal();

  const handleEscPressed = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        hideModal();
      }
    },
    [hideModal],
  );

  // * popstate fires on browser back/forward button presses but not on
  // * programmatic navigate() calls, so this only affects history navigation
  const handlePopState = useCallback(() => {
    hideModal();
  }, [hideModal]);

  useEffect(() => {
    document.addEventListener('keydown', handleEscPressed, false);
    return () => {
      document.removeEventListener('keydown', handleEscPressed, false);
    };
  }, [handleEscPressed]);

  useEffect(() => {
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [handlePopState]);
};
